import React from 'react'
import { Divider as MuiDivider } from '@material-ui/core'

const Divider = () => <MuiDivider />

export default Divider
